import { User } from '@sentry/angular';

export const isUserMissingData = (user: User): boolean => {
  const { country, first_name, last_name } = user;

  return !country || !first_name || !last_name;
};
